import script from "./OrderSummaryBottomSheet.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderSummaryBottomSheet.vue?vue&type=script&setup=true&lang=js"

import "./OrderSummaryBottomSheet.vue?vue&type=style&index=0&id=62723992&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62723992"]])

export default __exports__